export default "__VITE_ASSET__CXNpUGsV__"